'use client';

import { useCallback } from 'react';

import { Checkbox } from '@personly/libs-widgets';

import { useConsents } from '../../providers/consents';

interface Props {
  cookieTypes: any;
}

const CookieTypesSelect = ({ cookieTypes }: Props) => {
  const { selectedCookieTypes, setSelectedCookieTypes } = useConsents();

  const checked = useCallback(
    (handle) => selectedCookieTypes.includes(handle),
    [selectedCookieTypes]
  );

  const select = useCallback(
    (handle) => {
      if (selectedCookieTypes.includes(handle)) {
        setSelectedCookieTypes((value) =>
          value.filter((typeHandle) => typeHandle !== handle)
        );
      } else {
        setSelectedCookieTypes((value) => [...value, handle]);
      }
    },
    [selectedCookieTypes, setSelectedCookieTypes]
  );

  return cookieTypes.map((cookieType) => (
    <div key={cookieType.handle}>
      <div className="flex flex-row">
        <div className="pr-2">
          <Checkbox
            disabled={cookieType.flags.isDisabled}
            checked={checked(cookieType.handle)}
            onChange={() => select(cookieType.handle)}
          />
        </div>
        <div>{cookieType.title}</div>
      </div>
    </div>
  ));
};

export default CookieTypesSelect;
